<mat-toolbar color="primary">
  <span>
    <a class="h-logo" (click)="onClickHome()">
      <img
        width="40"
        alt="Angular Logo"
        src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNTAgMjUwIj4KICAgIDxwYXRoIGZpbGw9IiNERDAwMzEiIGQ9Ik0xMjUgMzBMMzEuOSA2My4ybDE0LjIgMTIzLjFMMTI1IDIzMGw3OC45LTQzLjcgMTQuMi0xMjMuMXoiIC8+CiAgICA8cGF0aCBmaWxsPSIjQzMwMDJGIiBkPSJNMTI1IDMwdjIyLjItLjFWMjMwbDc4LjktNDMuNyAxNC4yLTEyMy4xTDEyNSAzMHoiIC8+CiAgICA8cGF0aCAgZmlsbD0iI0ZGRkZGRiIgZD0iTTEyNSA1Mi4xTDY2LjggMTgyLjZoMjEuN2wxMS43LTI5LjJoNDkuNGwxMS43IDI5LjJIMTgzTDEyNSA1Mi4xem0xNyA4My4zaC0zNGwxNy00MC45IDE3IDQwLjl6IiAvPgogIDwvc3ZnPg=="
      />
      <span class="reponsive-title">Searching Hub</span>
    </a>
  </span>
  <span class="spacer"></span>
  <span>
    <mat-form-field>
      <input
        matInput
        type="search"
        name="searchText"
        id="searchText"
        [(ngModel)]="searchText"
        #ctrl="ngModel"
        (keypress)="onKeyPress($event)"
        required
      />
    </mat-form-field>
    <button
      color="warn"
      mat-mini-fab
      aria-label="Seacrh icon-button with a searcg icon"
      (click)="onSearch()"
    >
      <mat-icon aria-hidden="false" aria-label="Search icon">search</mat-icon>
    </button>
  </span>
</mat-toolbar>
